export default "__VITE_ASSET__BcMA$ZEe__"